import PageContentBlock from '@/components/page-content-block/page-content-block';
import { useEnvStore } from '@/store/env.store';
import { usePlayersReportStore } from '@/store/players-report/players-report.store';
import { storeToRefs } from 'pinia';
import { computed, defineComponent, onMounted } from 'vue';

export default defineComponent({
  name: 'PlayersReport',
  components: {
    PageContentBlock,
  },
  setup() {
    const { WL_SLUG } = storeToRefs(useEnvStore());
    const playersReportStore = usePlayersReportStore();
    const { playersReport } = storeToRefs(playersReportStore);
    const { getPlayersReport } = playersReportStore;

    const totalPlayersCount = computed<number>(
      () => playersReport.value?.totalPlayersCount ?? 0,
    );

    const totalPlayersOnlineCount = computed<number>(
      () => playersReport.value?.totalPlayersOnlineCount ?? 0,
    );

    onMounted(() => {
      getPlayersReport(WL_SLUG.value);
    });

    return {
      totalPlayersCount,
      totalPlayersOnlineCount,
    };
  },
});
